export enum ProposalStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED'
}

export enum CurrencyType {
  USD = 'USD',
  EUR = 'EUR',
  TRY = 'TRY',
  GBP = 'GBP'
}

export enum HandoffType {
  FULL_HANDOFF = 'FULL_HANDOFF'
}

export interface Timeline {
  proposal_id?: string;
  service: string;
  time: number;
  possible_delay: number;
}

export interface StageItem {
  title: string;
  detail: string;
}

export interface Stage {
  proposal_id?: string;
  stage_number: number;
  items: StageItem[];
  main_item?: StageItem | null;
}

export interface Deliverable {
  proposal_id?: string;
  service: string;
  led_by: string;
  handoff: HandoffType;
}

export interface Table {
  proposal_id?: string;
  service: string;
  monthly_cost: number;
  monthly_cost_currency: string;
  months: number;
  total_cost: number;
  total_cost_currency: string;
}

export interface Proposal {
  id?: string;
  project_id: string;
  status: ProposalStatus;
  overview: string;
  scope_of_work: string;
  quotation_details: string;
  not_included_in_price: string;
  currency_type: CurrencyType;
  price: number;
  user_id: string;
  project_lead_id: string;
  expected_project_time: number;
  expected_project_cost: number;
  expected_project_cost_currency: string;
  timelines: Timeline[];
  stages: Stage[];
  deliverables: Deliverable[];
  tables: Table[];
  generated_password?: string;
  pin_code?: string;
  created_at?: string;
  updated_at?: string;
  is_active?: boolean;
  is_deleted?: boolean;
}

export type ProposalCreateInput = Omit<Proposal, 'id' | 'generated_password' | 'pin_code' | 'created_at' | 'updated_at' | 'is_active' | 'is_deleted'>;
export type ProposalUpdateInput = Proposal;

// Validation types for form fields
export interface ProposalValidationErrors {
  project_id?: string;
  user_id?: string;
  project_lead_id?: string;
  quotation_details?: string;
  price?: string;
  overview?: string;
  scope_of_work?: string;
  currency_type?: string;
  status?: string;
  expected_project_time?: string;
  timelines?: string;
  stages?: string;
  deliverables?: string;
  tables?: string;
}

// Response types that match backend structure
export interface ProposalResponse {
  data: Proposal;
  error?: string;
  message?: string;
}

export interface ProposalsResponse {
  data: Proposal[];
  error?: string;
  message?: string;
}

export interface Task {
  title: string;
  description: string;
}

export interface StageWithTasks {
  stage: Stage;
  tasks: Task[];
}

export interface Service {
  name: string;
  led_by: string;
  handoff: string;
}

export interface CostBreakdown {
  name: string;
  monthly_cost: number;
  months: number;
  total_cost: number;
}

export interface ProjectLead {
  name: string;
  photo_url?: string;
}

export interface TimelineTable {
  service: string;
  time: string;
  possible_delays: string;
} 